<template>
  <v-app>
    <Top v-if="user" :user="user"  :sioVar="sioVar"/>
    <Left v-if="user"  />
    <vue-page-transition  name="fade-in-left">
      <router-view class="router-wrapper" :key="update_view" />
    </vue-page-transition>
  </v-app>
</template>

<script>
import auth from './services/auth'
import graph from './services/graph'
import gsap from "gsap";
import Login from './components/generalComponents/Login'
import DetailsModal from '@/components/generalComponents/DetailsModal'
import Left from '@/components/generalComponents/Navigation/Left'
import Top from '@/components/generalComponents/Navigation/Top'
import person from "./apiCallers/person"  
import SocketioService from '@/services/socketio.service.js';
import {refreshLogoutTimer} from "@/plugins/timer.js"
import $ from 'jquery';

export default {
  name: 'App',

  components: { Login, DetailsModal, Left, Top },

  data: function() {
    return {

      sioVar : null,

      // User account object synced with MSAL getAccount()
      user: {},
      // Access token fetched via MSAL for calling Graph API
      accessToken: '',

      // Details fetched from Graph API, user object and photo
      graphDetails: null,
      graphPhoto: null,

      // Visibility toggles for the three details modal popups
      showUserDetails: false,
      showGraphDetails: false,
      showTokenDetails: false,


      accessToken : null,
      update_view : 1,

      // Any errors
      error: ''
    }
  },

  watch: {
    $route (to, from){
        if(to != from)
        {
          refreshLogoutTimer();
          this.$store.state.paginacija.subpages = [];
          this.$store.state.paginacija.back_link = '';
          this.update_view++;
          this.$store.state.event_details.popup_open = false;
          this.$store.state.rocista_tab_active = false;
          this.$store.state.edit_data = null;
          this.$store.state.last_page_name = from.name;
          this.$store.state.spis_active_pic = null;
          this.$store.state.spis_overlay_open = false;
          
          if(!this.$store.state.event_details.popup_open){
            gsap.to(".mainH",0,{overflow:"auto"});
          }
          if(this.$store.state.logged_in_user == undefined || this.$store.state.logged_in_user == null)
          {
            person.getSelf(this.accessToken).then((resp) => {
              this.$store.state.logged_in_user = resp.data;
           })
          }
          if (window.matchMedia("only screen and (max-width: 560px)").matches) {
            $('.mobile-menu input')[0].checked=false;
            $(".navigation").removeClass("opened");
            gsap.to('.nav-item-hover',0.5,{display:'none', opacity:0, left:'4rem'})
            console.log("is mobile");
          }

        }
    },
    // If user changes, make calls to Graph API
    'user': async function () {
      this.fetchGraphDetails()
    },
  },

  async created() {
    // Basic setup of MSAL helper with client id, or give up
    if (process.env.VUE_APP_CLIENT_ID) {
      auth.configure(process.env.VUE_APP_CLIENT_ID)

      // Restore any cached or saved local user
      this.user = auth.user()
      this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);

      await person.getSelf(this.accessToken).then((resp) => {
              SocketioService.setupSocketConnection(resp.data.uid);
              this.$store.state.logged_in_user = resp.data;
              this.sioVar = SocketioService;
              this.$store.state.sioVar = SocketioService;
           })

    } else {
      this.error = 'VUE_APP_CLIENT_ID is not set, the app will not function!'
    }
  },

  methods: {
    // Update user from MSAL
    updateUser() {
      this.user = auth.user()
    },

    // Remove locally held user details, is same as logout
    shallowLogout() {
      this.user = null
      this.graphDetails = null
      this.userDetails = null
      this.graphPhoto = null
      auth.getAccessToken
      auth.clearLocal()
    },

    // Full logout local & server side
    fullLogout() {
      auth.logout
    },

    // Get an access token and call graphGetSelf & graphGetPhoto
    async fetchGraphDetails() {
      if (!this.user) { return }

      try {
        this.graphPhoto = await graph.getPhoto()
        console.log(this.graphPhoto);
        this.accessToken = graph.getAccessToken()
        // const msg = await axios.get("https://app-psod.cratis.cloud/calendar/calendars", {params:{"uid" : this.accessToken},credentials: true})
        // console.log(msg)
        person.getFilteredUsers(this.accessToken);
        
        person.getSelf(this.accessToken).then((response)=>{
          this.graphDetails = response.data
        });
      } catch (err) {
        this.error = err
      }
      
    }
  }
}
</script>

<style>
 @import "./assets/css/style.css";
 @import "./assets/css/forms.css";
 @import url('https://fonts.googleapis.com/css2?family=Barlow:wght@300;400;500;700&display=swap');
</style>